export const LEGAL_NOTICE = {
  version: '1.0',
  lastUpdated: '2026-06-20',
  publisherName: 'The Tavern',
  publisherOperator: 'Sarto',
  legalForm: 'To be completed before public launch',
  siren: 'To be completed before public launch',
  vatNumber: 'To be completed before public launch',
  registeredAddress: 'To be completed before public launch',
  publicationDirector: 'To be completed before public launch',
  contactEmail: 'contact@thetavern.fr',
  hostingProviderName: 'Self-managed server / VPS',
  hostingProviderWebsite: null,
  hostingProviderNote:
    'The repository documents a Docker Compose deployment on ubuntu@thetavern.fr under /opt/thetavern. The exact hosting company must be completed before the public launch.',
};

